module.exports = __webpack_public_path__ + "static/media/niyoGreenLogo.48e6c3d3.png";